import { render, staticRenderFns } from "./CreatedHolidayRule.vue?vue&type=template&id=151d5a08&scoped=true"
import script from "./CreatedHolidayRule.vue?vue&type=script&lang=js"
export * from "./CreatedHolidayRule.vue?vue&type=script&lang=js"
import style0 from "./CreatedHolidayRule.vue?vue&type=style&index=0&id=151d5a08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "151d5a08",
  null
  
)

export default component.exports